import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { registerRedirectToLogin } from "../hooks/session";

/**
 * SessionRedirectBridge — Bridges the non-React SWR read path (authFetcher) to
 * React Router (DEF-015).
 *
 * `authFetcher` runs outside the component tree, so when a read 401s and the
 * silent refresh fails it can't call `useNavigate` itself. This component (one
 * instance, mounted under the Router in App) registers a navigate-backed
 * redirect handler with session.js for the lifetime of the app.
 *
 * Renders nothing.
 */
export default function SessionRedirectBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    const unregister = registerRedirectToLogin((from) => {
      if (from) {
        navigate("/login", { replace: true, state: { from } });
      } else {
        navigate("/login", { replace: true });
      }
    });
    return unregister;
  }, [navigate]);

  return null;
}
